import { useEffect, useState } from "react";
import { CircleNotch } from "@phosphor-icons/react";

const STEPS = {
  upload: ["Uploading photo"],
};

export default function AiScanOverlay({ phase }) {
  const [i, setI] = useState(0);
  const [pct, setPct] = useState(4);
  useEffect(() => {
    setI(0);
    setPct(phase === "upload" ? 10 : 24);
    const n = (STEPS[phase] || []).length;
    const t = setInterval(() => {
      setI((v) => Math.min(v + 1, n - 1));
      setPct((p) => Math.min(p + (94 - p) * 0.18, 94));
    }, 2600);
    return () => clearInterval(t);
  }, [phase]);
  if (!phase) return null;
  const steps = STEPS[phase];
  return (
    <div className="absolute inset-0 bg-background/30 flex items-end p-3 animate-in fade-in duration-300" data-testid="ai-scan-overlay" data-phase={phase} role="status" aria-live="polite">
      <div className="w-full rounded-2xl bg-background/80 backdrop-blur-xl px-3.5 py-3 shadow-[0_8px_24px_-12px_rgba(0,0,0,0.3)]">
        <div className="flex items-center gap-2.5">
          <CircleNotch weight="bold" className="h-4 w-4 text-muted-foreground animate-spin shrink-0" />
          <div className="min-w-0 flex-1">
            <p className="text-[10px] text-muted-foreground">{phase === "upload" ? "Uploading" : `Identifying · ${i + 1} of ${steps.length}`}</p>
            <p key={i} className="text-[13px] font-medium tracking-tight truncate animate-in fade-in duration-500" data-testid="ai-scan-step">{steps[i]}</p>
          </div>
        </div>
        <div className="mt-2.5 h-[3px] rounded-full bg-foreground/10 overflow-hidden">
          <div className="h-full rounded-full bg-foreground/70 transition-[width] duration-1000 ease-out" style={{ width: `${pct}%` }} />
        </div>
      </div>
    </div>
  );
}
